"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var CashSummaryBlocks_1 = require("./Cash/CashSummaryBlocks");
var globalTypes_1 = require("../../../../../../__generated__/globalTypes");
var FinanceSummaryBlock_1 = require("./Finance/FinanceSummaryBlock");
var FinanceBreakdownSummaryBlockContainer = function (_a) {
    var finance = _a.finance, isMultiCurrency = _a.isMultiCurrency, prices = _a.prices, taxLabel = _a.taxLabel;
    var isFinanceDeal = react_1.useMemo(function () { var _a; return ((_a = finance) === null || _a === void 0 ? void 0 : _a.type) === globalTypes_1.FinanceFormType.finance; }, [finance]);
    if (isFinanceDeal) {
        return <FinanceSummaryBlock_1.default finance={finance} isMultiCurrency={isMultiCurrency} taxLabel={taxLabel}/>;
    }
    return <CashSummaryBlocks_1.default prices={prices} isMultiCurrency={isMultiCurrency}/>;
};
exports.default = FinanceBreakdownSummaryBlockContainer;
